import {
  Grid,
  Button,
  DialogActions,
  Stack,
  Box,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Chip,
  Fade,
  FormControl,
  Menu,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  LinearProgress
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import forms from '../../../../resources/forms.json';
import AppModal from 'src/components/modal';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import { useDispatch } from 'react-redux/es/hooks/useDispatch';
import { setMessage } from 'src/store/Message';
import { useUser } from 'src/components/hooks/useUser';
import {
  useCreateQueryMutation,
  useDeleteQueryMutation,
  useForwardQueryMutation,
  useUpdateQueryMutation
} from 'src/services/Queries';
import { useAppSelector } from 'src/store/hooks';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ForwardIcon from '@mui/icons-material/Forward';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useAllAssigneesQuery } from 'src/services/Utils';
// import { sortBy } from 'lodash';
// import { CSVLink } from 'react-csv';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useCreateQueryResponseMutation } from 'src/services/QueryResponse';
import { hideLoader, showLoader } from 'src/store/Loader';
import Loader from 'src/components/common/Loader';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import moment from 'moment';
import { archLevel } from 'src/data/config';
import { useUtil } from 'src/components/hooks/useUtil';

export default function ViewQuery({
  openQueryDialog,
  setOpenQueryDialog,
  setOpenRaiseQuery,
  openRaiseQuery,
  queryObj,
  id,
  getQueries,
  showQuerys,
  isSectionQuery,
  setIsSectionQuery,
  getQueriesIsLoading
}: any) {
  const [confirmDailog, setConfirmDailog] = useState(false);
  const [openForwordQuery, setOpenForwordQuery] = useState(false);
  const formGroup = queryObj.filedType === 'Row' ? forms.RaiseQueryFormRow : forms.RaiseQueryFormField;
  const [codes, setCodes]: any = useState({});
  const formGroupForwordQuery = forms.ForwardFormField;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups, codes);
  const {
    formFields: forwordQueryFormFields,
    defaultValues: forwordQuerydefaultValues = {},
    rules: forwordQueryRules
  } = getFormData(formGroupForwordQuery.groups, codes);
  const { groups } = formFields;
  const { groups: forwordQueryGroups } = forwordQueryFormFields;
  const dispatch = useDispatch();
  const formRef: any = useRef(null);
  const { user } = useUser();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [expanded, setExpanded] = useState<string | false>(false);
  const [forwordQueryData, setForwordQueryData] = useState<any>({});
  const [openDeleteQuery, setOpenDeleteQuery] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const responseTextRef: any = useRef(null);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { handleError } = useUtil();
  const [
    createQuery,
    {
      isLoading: createQueryIsLoading,
      isSuccess: createQueryIsSuccess,
      data: createQueryData,
      isError: createQueryIsError,
      error: createQueryError
    }
  ] = useCreateQueryMutation();

  const [
    createQueryRes,
    {
      isLoading: createQueryResIsLoading,
      isSuccess: createQueryResIsSuccess,
      data: createQueryResData,
      isError: createQueryResIsError,
      error: createQueryResError
    }
  ] = useCreateQueryResponseMutation();

  const {
    isSuccess: allAssigneesIsSuccess,
    data: allAssigneesData,
    isLoading: allAssigneesIsLoading
  } = useAllAssigneesQuery();
  const [
    updateQuery,
    {
      isLoading: updateQueryIsLoading,
      isSuccess: updateQueryIsSuccess,
      data: updateQueryData,
      isError: updateQueryIsError,
      error: updateQueryError
    }
  ] = useUpdateQueryMutation();
  const [
    forwardQuery,
    { isSuccess: forwardQueryIsSuccess, data: forwardQueryData, isError: forwardQueryIsError, error: forwardQueryError }
  ] = useForwardQueryMutation();
  useEffect(() => {
    if (updateCategory == 'Forward') {
      if (
        !updateQueryIsLoading &&
        (updateQueryIsSuccess || forwardQueryIsSuccess) &&
        (updateQueryData || forwardQueryData)
      ) {
        setOpenForwordQuery(false);
        dispatch(setMessage({ msgDetails: 'Query forwarded successfully', severity: 'success' }));
        getQueries();
      } else if (
        !updateQueryIsLoading &&
        (updateQueryError || forwardQueryError) &&
        (updateQueryIsError || forwardQueryIsError)
      ) {
        const err: any = updateQueryError || forwardQueryError;      
        handleError(err, true);
        if (err?.status == 404) {
          //getQueries();
          setOpenForwordQuery(false);
        }
      }
    }
  }, [
    updateQueryIsLoading,
    updateQueryIsSuccess,
    updateQueryData,
    updateQueryIsError,
    updateQueryError,
    forwardQueryIsSuccess,
    forwardQueryData,
    forwardQueryIsError
  ]);
  const handleChangeAccordion = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  useEffect(() => {
    if (!createQueryIsLoading && createQueryIsSuccess && createQueryData) {
      if (isSectionQuery) {
        dispatch(setMessage({ msgDetails: 'Section query is raised successfully', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: 'Query is raised successfully', severity: 'success' }));
      }
      setIsSectionQuery(false);
      getQueries();
    } else if (!createQueryIsLoading && createQueryIsError && createQueryError) {
      // const err: any = createQueryError;
      handleError(createQueryError);
    }
  }, [createQueryIsLoading, createQueryIsSuccess, createQueryData, createQueryIsError, createQueryError]);
  useEffect(() => {
    const TempCodeList: any = {};
    if (queryObj.filedType === 'Row') {
      TempCodeList.SFQ = queryObj.filedData.map((ele: any) => {
        return {
          displayName: ele.title,
          key: ele.title
        };
      });
    }
    groups.map((obj: any) => {
      obj?.fields.map((field: any) => {
        if (field.name == 'send_to' && !allAssigneesIsLoading && allAssigneesIsSuccess && allAssigneesData?.length) {
          field.values = [...new Set(allAssigneesData.map((ele: any) => `${ele.firstName} ${ele.lastName}`))];
        }
      });
    });
    forwordQueryGroups.map((obj: any) => {
      obj?.fields.map((field: any) => {
        if (field.name == 'forward_to' && !allAssigneesIsLoading && allAssigneesIsSuccess && allAssigneesData?.length) {
          field.values = [...new Set(allAssigneesData.map((ele: any) => `${ele.firstName} ${ele.lastName}`))];
        }
      });
    });
    setCodes({ ...TempCodeList });
  }, [queryObj, allAssigneesIsSuccess, allAssigneesData]);

  const handleRaiseQuery = () => {
    setOpenRaiseQuery(true);
  };
  const handleSubmit = () => {
    formRef.current.submit(onFormSubmit);
  };
  const handleSubmitForwordQ = () => {
    formRef.current.submit(onSubmitFQuery);
  };

  const onFormSubmit = async (data: any) => {
    if (data.errors) {
      dispatch(setMessage({ msgDetails: 'Mandatory Information is Missing.', severity: 'error' }));
      return;
    }

    if (data.success && queryObj.filedType === 'Row') {
      const find = queryObj.filedData.find((ele: any) => ele.title === data.records.select_field);
      const payload = {
        report_category: 'CRFFLDQRY', // Static
        report_section_name: isSectionQuery ? find.section_name : 'CRF',
        report_field_name: find.key,
        report_field_label: find.title,
        report_field_value: '',
        report_query_type: isSectionQuery ? 'Section' : 'Field',
        report_comment: data.records.message,
        report_send_to: data.records.send_to,
        report_is_opened: true,
        report_id: id,
        created_by: user
      };
      const createObj = {
        site_id: selectedSite || '',
        study_id: studyId || '',
        country: selectedCountry || '',
        application: process.env.REACT_APP_NAME,
        data: payload,
        application_section: 'CONDUCT',
        application_module_section: 'CRFENTRY'
      };
      await createQuery(createObj);
      setOpenRaiseQuery(false);
    } else if (data.success) {
      const payload = {
        report_category: 'CRFFLDQRY',
        report_section_name: isSectionQuery ? queryObj.filedData.section_name : 'CRF',
        report_field_name: queryObj.filedData.key,
        report_field_label: queryObj.filedData.title,
        report_field_value: '',
        report_query_type: isSectionQuery ? 'Section' : 'Field',
        report_comment: data.records.message,
        report_send_to: data.records.send_to,
        report_is_opened: true,
        report_status: '',
        report_id: id,
        created_by: user
      };
      const createObj = {
        site_id: selectedSite || '',
        study_id: studyId || '',
        country: selectedCountry || '',
        application: process.env.REACT_APP_NAME,
        data: payload,
        application_section: 'CONDUCT',
        application_module_section: 'CRFENTRY'
      };
      await createQuery(createObj);
      setOpenRaiseQuery(false);
    }
  };

  const [unResolvedQueryId, setUnResolvedQueryId] = useState<any>(null);
  const [updateCategory, setUpdateCategory] = useState<any>('');

  const handleUnresolvedQuery = async (query: any) => {
    const dataObj = {
      report_category: query.report_category,
      report_section_name: 'CRF',
      report_field_name: query.report_field_name,
      report_field_label: query.report_field_label,
      report_field_value: query.report_field_value,
      report_query_type: query.report_query_type,
      report_comment: query.report_comment,
      report_send_to: query.report_send_to,
      report_forward_to: query.report_forward_to,
      report_is_opened: false,
      report_status: query.report_status,
      report_id: query.report_id,
      report_query_id:
        query.report_field_query_id_v?.split('-')?.[2] || query.report_section_query_id_v?.split('-')?.[2],
      updated_by: user
    };
    const updateObj = {
      site_id: selectedSite || '',
      study_id: studyId || '',
      country: selectedCountry || '',
      application: process.env.REACT_APP_NAME,
      data: dataObj,
      application_section: 'CONDUCT',
      application_module_section: 'CRFENTRY'
    };
    await updateQuery(updateObj);
    setConfirmDailog(false);
    setUnResolvedQueryId(null);
  };

  useEffect(() => {
    if (!updateQueryIsLoading && updateQueryIsSuccess && updateQueryData && updateCategory == 'Resolve') {
      dispatch(setMessage({ msgDetails: 'Query resolved successfully', severity: 'success' }));
      getQueries();
    } else if (!updateQueryIsLoading && updateQueryIsError && updateQueryError && updateCategory == 'Resolve') {
      const err: any = updateQueryError;
      if (err?.status === 500 || err?.status === 502 || err?.status === 504 || err?.status === 503) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else {
        dispatch(
          setMessage({
            msgDetails: 'Internal Server Error',
            severity: 'error'
          })
        );
      }
    }
  }, [updateQueryIsLoading, updateQueryIsSuccess, updateQueryData, updateQueryIsError, updateQueryError]);

  useEffect(() => {
    if (updateQueryIsLoading || createQueryResIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [updateQueryIsLoading, createQueryResIsLoading]);

  const [comment, setComment] = useState<any>('');

  const handleSendComment = (query: any) => {
    const dataObj: any = {
      query_response: comment,
      is_opened: true,
      created_by: user
    };
    const createObj: any = {
      query_id: query.id,
      site_id: selectedSite || '',
      study_id: studyId || '',
      country: selectedCountry || '',
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG,
      application_section: 'CONDUCT',
      application_module_section: 'CRFENTRY',
      data: dataObj
    };
    if (comment && comment.length > 0) {
      createQueryRes(createObj);
      setComment('');
    } else {
      dispatch(
        setMessage({
          msgDetails: 'Empty comment cannot be added',
          severity: 'error'
        })
      );
    }
  };

  useEffect(() => {
    if (!createQueryResIsLoading && createQueryResIsSuccess && createQueryResData) {
      dispatch(setMessage({ msgDetails: 'Response added successfully', severity: 'success' }));
      getQueries();
    } else if (!createQueryResIsLoading && createQueryResIsError && createQueryResError) {
      const err: any = createQueryResError;
      if (err?.status === 500 || err?.status === 502 || err?.status === 504 || err?.status === 503) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else {
        dispatch(
          setMessage({
            msgDetails: 'Internal Server Error',
            severity: 'error'
          })
        );
      }
    }
  }, [
    createQueryResIsLoading,
    createQueryResIsSuccess,
    createQueryResData,
    createQueryResIsError,
    createQueryResError
  ]);
  const onSubmitFQuery = async (data: any) => {
    if (data.errors) {
      dispatch(setMessage({ msgDetails: 'Mandatory Information is Missing.', severity: 'error' }));
      return;
    }
    if (data.success) {
      const payload = {
        report_category: forwordQueryData.query.report_category,
        report_field_name: forwordQueryData.query.report_field_name,
        report_field_label: forwordQueryData.query.report_field_label,
        report_field_value: forwordQueryData.query.report_field_value,
        report_send_to: forwordQueryData.query.report_send_to,
        report_query_type: forwordQueryData.query.report_query_type,
        report_comment: data.records.message,
        report_forward_to: data.records.forward_to,
        report_is_opened: true,
        report_status: '',
        report_id: id,
        report_query_id:
          forwordQueryData?.query?.report_field_query_id_v?.split('-')[2] ||
          forwordQueryData?.query?.report_section_query_id_v?.split('-')[2],
        updated_by: user
      };

      const createObj = {
        site_id: selectedSite || '',
        study_id: studyId || '',
        country: selectedCountry || '',
        application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG,
        data: payload,
        application_section: 'CONDUCT',
        application_module_section: 'CRFENTRY'
      };
      if (archLevel === 'sponsor') {
        updateQuery(createObj);
      } else {
        forwardQuery(createObj);
      }
    }
  };
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>, data: any) => {
    setForwordQueryData(data);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMore = () => {
    setAnchorEl(null);
  };
  const handleRemoveQuery = () => {
    setOpenDeleteQuery(true);
    setAnchorEl(null);
  };
  const handleForwordQuery = () => {
    setOpenForwordQuery(true);
    setAnchorEl(null);
  };
  const [
    deleteQuery,
    {
      isLoading: deleteQueryIsLoading,
      isSuccess: deleteQueryIsSuccess,
      data: deleteQueryData,
      isError: deleteQueryIsError,
      error: deleteQueryError
    }
  ] = useDeleteQueryMutation();
  useEffect(() => {
    if (!deleteQueryIsLoading && deleteQueryIsSuccess && deleteQueryData) {
      setOpenDeleteQuery(false);
      dispatch(setMessage({ msgDetails: 'Query is removed successfully', severity: 'success' }));
      getQueries();
    } else if (!deleteQueryIsLoading && deleteQueryIsError && deleteQueryError) {
      const err: any = deleteQueryError;
      if (err?.status === 500 || err?.status === 502 || err?.status === 504 || err?.status === 503) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else {
        dispatch(
          setMessage({
            msgDetails: 'Internal Server Error',
            severity: 'error'
          })
        );
      }
    }
  }, [deleteQueryIsLoading, deleteQueryIsSuccess, deleteQueryData, deleteQueryIsError, deleteQueryError]);

  const handleDeleteQuery = async () => {
    const reqObj = {
      report_query_id:
        forwordQueryData?.query?.report_field_query_id_v?.split('-')[2] ||
        forwordQueryData?.query?.report_section_query_id_v?.split('-')[2],
      deleted_by: user
    };
    const createObj = {
      site_id: selectedSite || '',
      study_id: studyId || '',
      country: selectedCountry || '',
      application: process.env.REACT_APP_NAME,
      data: reqObj,
      application_section: 'CONDUCT',
      application_module_section: 'CRFENTRY'
    };
    await deleteQuery(createObj);
  };

  useEffect(() => {
    getQueries();
  }, []);
  return (
    <>
      {/* Show Query Dialog */}
      <PopupComponent open={openQueryDialog} child sx={{ '& .MuiDialog-paper': { maxWidth: 'unset !important' } }}>
        <Loader />
        <DialogContent
          dividers
          className="audit-history-modal1"
          sx={{ minWidth: 800, maxWidth: '900px !important', maxHeight: 400 }}
        >
          <div className="audit-card sivreport-audit-history">
            <Grid container spacing={0}>
              <Grid item md={12}>
                <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', pt: 0 }}>
                  <Grid container sx={{ alignItems: 'center' }} mb={2} spacing={0}>
                    <Grid item md={6}>
                      <h2 style={{ margin: 0 }}>Query</h2>
                    </Grid>
                    {checkPermission('raise_crf_query') ? (
                      <Grid item md={6}>
                        <Button variant="contained" sx={{ float: 'right' }} onClick={handleRaiseQuery}>
                          Raise Query
                        </Button>
                      </Grid>
                    ) : null}
                  </Grid>
                </Box>
                {getQueriesIsLoading ? (
                  <Box>
                    <LinearProgress />
                  </Box>
                ) : null}
              </Grid>
              {showQuerys.length ? (
                <Grid container>
                  <Grid item md={12}>
                    <Box sx={{ mb: 2 }}>
                      <Grid container>
                        <Grid item md={12}>
                          <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                            {`Section`} Queries (
                            {showQuerys.filter((ele: any) => ele.query.report_query_type === 'Section').length})
                          </Typography>
                        </Grid>
                      </Grid>
                      {showQuerys &&
                        showQuerys.map((queryObj: any) => {
                          if (queryObj.query.report_query_type === 'Section') {
                            return (
                              <Grid container key={queryObj.query.id}>
                                <Grid item md={12}>
                                  <Card className="query-card">
                                    <CardContent>
                                      <Grid container sx={{ pb: 2 }} spacing={3}>
                                        <Grid item md={8} className="name-section">
                                          <AccountCircleIcon />
                                          {queryObj.query.created_by}
                                          <span>
                                            {moment(queryObj.query.created_on).format(
                                              `${userPreferedDateFormat.toUpperCase()} hh:mm A`
                                            )}
                                          </span>
                                          <Chip
                                            label={`${queryObj.query.report_query_type} Query`}
                                            color="success"
                                            size="small"
                                          />
                                        </Grid>
                                        <Grid
                                          item
                                          md={4}
                                          className="more-section"
                                          display="flex"
                                          justifyContent="flex-end"
                                        >
                                          {queryObj.query.report_is_opened == false ? (
                                            <div className="grey-btn" title="Resolved Query">
                                              <CheckCircleIcon sx={{ fill: '#41B487 !important' }} />
                                            </div>
                                          ) : (
                                            <IconButton
                                              title="Unresolved Query"
                                              onClick={() => {
                                                setConfirmDailog(true);
                                                setUnResolvedQueryId(queryObj.query);
                                              }}
                                              disabled={
                                                !checkPermission('raise_crf_query') ||
                                                queryObj?.query?.report_status == 'Automated' // property need to modify from api team
                                              }
                                              className="grey-btn"
                                            >
                                              <CheckCircleOutlineIcon />
                                            </IconButton>
                                          )}

                                          <div>
                                            <IconButton
                                              title="More options"
                                              disabled={queryObj.query.report_is_opened == false}
                                              id="fade-button"
                                              aria-controls={'fade-menu'}
                                              aria-haspopup="true"
                                              aria-expanded={'true'}
                                              sx={{ fill: '#41B487 !important' }}
                                              onClick={(e: React.MouseEvent<HTMLElement>) => handleClick(e, queryObj)}
                                            >
                                              <MoreHorizIcon />
                                            </IconButton>
                                          </div>
                                        </Grid>
                                        <Grid item md={12}>
                                          <span className="sub-text">
                                            <strong>ID:</strong>{' '}
                                            {queryObj.query.report_query_type == 'Field'
                                              ? queryObj.query.report_field_query_id_v
                                              : queryObj.query.report_section_query_id_v}
                                          </span>
                                          <span className="sub-text">
                                            <strong>Field:</strong> {queryObj.query.report_field_label}
                                          </span>
                                          <span className="sub-text">
                                            <strong>
                                              {queryObj.query.report_forward_to != null
                                                ? 'Initially Sent To'
                                                : 'Send To'}
                                              :
                                            </strong>{' '}
                                            {queryObj.query.report_send_to}
                                          </span>
                                          {queryObj.query.report_forward_to != null && (
                                            <span className="sub-text">
                                              <strong>Forwarded To:</strong> {queryObj.query.report_forward_to}
                                            </span>
                                          )}
                                          <span className="sub-text">
                                            <strong>Message:</strong> {queryObj.query.report_comment}
                                          </span>
                                        </Grid>
                                      </Grid>

                                      {checkPermission('respond_query_crf') ? (
                                        <Grid container>
                                          <Grid item md={12}>
                                            <Accordion
                                              expanded={expanded === queryObj.query.report_field_query_id_v}
                                              onChange={handleChangeAccordion(queryObj.query.report_field_query_id_v)}
                                              className="CustomAccordion-AH"
                                              sx={{
                                                mb: 0,
                                                '& .MuiAccordionSummary-expandIconWrapper': {
                                                  alignSelf: 'center !important',
                                                  marginTop: 0
                                                },
                                                '& .MuiAccordionSummary-content': { marginBottom: 0 }
                                              }}
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2bh-content"
                                                id="panel2bh-header"
                                                sx={{ mb: 0 }}
                                              >
                                                <Typography variant="h6" component="div" sx={{ mb: 0 }}>
                                                  {queryObj.responses && queryObj.responses.length} COMMENT
                                                  {queryObj.responses && queryObj.responses.length > 1 ? 'S' : ''}
                                                </Typography>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <Grid container>
                                                  {queryObj.responses &&
                                                    queryObj.responses.map((res: any) => {
                                                      return (
                                                        <div key={res.id}>
                                                          <Grid item md={12} className="name-section" sx={{ pl: 2 }}>
                                                            <AccountCircleIcon /> {res.created_by}
                                                            <span>
                                                              {moment(res.created_on).format(
                                                                `${userPreferedDateFormat.toUpperCase()} hh:mm A`
                                                              )}
                                                            </span>
                                                          </Grid>
                                                          <Grid md={12} sx={{ pl: 2.5, mb: 2, wordBreak: 'break-all' }}>
                                                            <span className="sub-text">{res.query_response}</span>
                                                          </Grid>
                                                        </div>
                                                      );
                                                    })}

                                                  <Grid container className="action-section">
                                                    <Grid item md={12}>
                                                      <FormControl fullWidth margin="normal" className="response-input">
                                                        <TextField
                                                          id="standard-disabled"
                                                          label="Response"
                                                          variant="standard"
                                                          inputProps={{ maxLength: 200 }}
                                                          disabled={!queryObj.query.report_is_opened}
                                                          onChange={(e: any) => setComment(e.target.value)}
                                                          value={comment}
                                                          ref={responseTextRef}
                                                        />
                                                      </FormControl>
                                                      <Button
                                                        variant="text"
                                                        disabled={!queryObj.query.report_is_opened}
                                                        onClick={() => handleSendComment(queryObj.query)}
                                                        className={!queryObj.query.report_is_opened ? 'grey-btn' : ''}
                                                      >
                                                        Send
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </AccordionDetails>
                                            </Accordion>
                                          </Grid>
                                        </Grid>
                                      ) : null}
                                    </CardContent>
                                  </Card>
                                </Grid>
                              </Grid>
                            );
                          }
                        })}
                      <Grid container>
                        <Grid item md={12}>
                          <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                            {`Field`} Queries (
                            {showQuerys.filter((ele: any) => ele.query.report_query_type === 'Field').length})
                          </Typography>
                        </Grid>
                      </Grid>
                      {showQuerys &&
                        showQuerys.map((queryObj: any) => {
                          if (queryObj.query.report_query_type === 'Field') {
                            return (
                              <Grid container key={queryObj.query.id}>
                                <Grid item md={12}>
                                  <Card className="query-card">
                                    <CardContent>
                                      <Grid container sx={{ pb: 2 }}>
                                        <Grid item md={8} className="name-section">
                                          <AccountCircleIcon />
                                          {queryObj.query.created_by}
                                          <span>
                                            {moment(queryObj.query.created_on).format(
                                              `${userPreferedDateFormat.toUpperCase()} hh:mm A`
                                            )}
                                          </span>
                                          <Chip
                                            label={`${queryObj.query.report_query_type} Query`}
                                            color="success"
                                            size="small"
                                          />
                                        </Grid>
                                        <Grid
                                          item
                                          md={4}
                                          className="more-section"
                                          display="flex"
                                          justifyContent="flex-end"
                                        >
                                          {queryObj.query.report_is_opened == false ? (
                                            <div className="grey-btn" title="Resolved Query">
                                              <CheckCircleIcon sx={{ fill: '#41B487 !important' }} />
                                            </div>
                                          ) : (
                                            <IconButton
                                              title="Unresolved Query"
                                              onClick={() => {
                                                setConfirmDailog(true);
                                                setUnResolvedQueryId(queryObj.query);
                                              }}
                                              disabled={
                                                !checkPermission('raise_crf_query') ||
                                                queryObj?.query?.report_status == 'Automated' // property need to modify from api team
                                              }
                                              className="grey-btn"
                                            >
                                              <CheckCircleOutlineIcon />
                                            </IconButton>
                                          )}

                                          <div>
                                            <IconButton
                                              title="More options"
                                              disabled={queryObj.query.report_is_opened == false}
                                              id="fade-button"
                                              aria-controls={'fade-menu'}
                                              aria-haspopup="true"
                                              aria-expanded={'true'}
                                              sx={{ fill: '#41B487 !important' }}
                                              onClick={(e: React.MouseEvent<HTMLElement>) => handleClick(e, queryObj)}
                                            >
                                              <MoreHorizIcon />
                                            </IconButton>
                                          </div>
                                        </Grid>
                                        <Grid item md={12}>
                                          <span className="sub-text">
                                            <strong>ID:</strong>{' '}
                                            {queryObj.query.report_query_type == 'Field'
                                              ? queryObj.query.report_field_query_id_v
                                              : queryObj.query.report_section_query_id_v}
                                          </span>
                                          <span className="sub-text">
                                            <strong>Field:</strong> {queryObj.query.report_field_label}
                                          </span>
                                          {queryObj.query.report_send_to ? (
                                            <span className="sub-text">
                                              <strong>
                                                {queryObj.query.report_forward_to != null
                                                  ? 'Initially Sent To'
                                                  : 'Send To'}
                                                :
                                              </strong>{' '}
                                              {queryObj.query.report_send_to}
                                            </span>
                                          ) : null}
                                          {queryObj.query.report_forward_to != null && (
                                            <span className="sub-text">
                                              <strong>Forwarded To:</strong> {queryObj.query.report_forward_to}
                                            </span>
                                          )}
                                          <span className="sub-text">
                                            <strong>Message:</strong> {queryObj.query.report_comment}
                                          </span>
                                        </Grid>
                                      </Grid>
                                      {checkPermission('respond_query_crf') ? (
                                        <Grid container>
                                          <Grid item md={12}>
                                            <Accordion
                                              expanded={expanded === queryObj.query.report_field_query_id_v}
                                              onChange={handleChangeAccordion(queryObj.query.report_field_query_id_v)}
                                              className="CustomAccordion-AH"
                                              sx={{
                                                mb: 0,
                                                '& .MuiAccordionSummary-expandIconWrapper': {
                                                  alignSelf: 'center !important',
                                                  marginTop: 0
                                                },
                                                '& .MuiAccordionSummary-content': { marginBottom: 0 }
                                              }}
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2bh-content"
                                                id="panel2bh-header"
                                                sx={{ mb: 0 }}
                                              >
                                                <Typography variant="h6" component="div" sx={{ mb: 0 }}>
                                                  {queryObj.responses && queryObj.responses.length} COMMENT
                                                  {queryObj.responses && queryObj.responses.length > 1 ? 'S' : ''}
                                                </Typography>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <Grid container>
                                                  {queryObj.responses &&
                                                    queryObj.responses.map((res: any) => {
                                                      return (
                                                        <div key={res.id}>
                                                          <Grid md={12} className="name-section" sx={{ pl: 2 }}>
                                                            <AccountCircleIcon /> {res.created_by}
                                                            <span>
                                                              {moment(res.created_on).format(
                                                                `${userPreferedDateFormat.toUpperCase()} hh:mm A`
                                                              )}
                                                            </span>
                                                          </Grid>
                                                          <Grid md={12} sx={{ pl: 2.5, mb: 2, wordBreak: 'break-all' }}>
                                                            <span className="sub-text">{res.query_response}</span>
                                                          </Grid>
                                                        </div>
                                                      );
                                                    })}

                                                  <Grid container className="action-section">
                                                    <Grid item md={12}>
                                                      <FormControl fullWidth margin="normal" className="response-input">
                                                        <TextField
                                                          id="standard-disabled"
                                                          label="Response"
                                                          variant="standard"
                                                          inputProps={{ maxLength: 200 }}
                                                          disabled={!queryObj.query.report_is_opened}
                                                          onChange={(e: any) => setComment(e.target.value)}
                                                          value={comment}
                                                          ref={responseTextRef}
                                                        />
                                                      </FormControl>
                                                      <Button
                                                        variant="text"
                                                        disabled={!queryObj.query.report_is_opened}
                                                        onClick={() => handleSendComment(queryObj.query)}
                                                        className={!queryObj.query.report_is_opened ? 'grey-btn' : ''}
                                                      >
                                                        Send
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </AccordionDetails>
                                            </Accordion>
                                          </Grid>
                                        </Grid>
                                      ) : null}
                                    </CardContent>
                                  </Card>
                                </Grid>
                              </Grid>
                            );
                          }
                        })}
                      <Menu
                        id="fade-menu"
                        MenuListProps={{
                          'aria-labelledby': 'fade-button'
                        }}
                        anchorEl={anchorEl}
                        open={anchorEl !== null}
                        onClose={handleCloseMore}
                        TransitionComponent={Fade}
                        className="remove-menu"
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right'
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right'
                        }}
                      >
                        {checkPermission('raise_crf_query') ? (
                          <MenuItem
                            onClick={() => handleRemoveQuery()}
                            disabled={forwordQueryData?.query?.report_status === 'Automated'}
                          >
                            <DeleteIcon /> Remove
                          </MenuItem>
                        ) : null}
                        {checkPermission('forward_crf_query') ? (
                          <MenuItem
                            onClick={() => {
                              setUpdateCategory('Forward');
                              handleForwordQuery();
                            }}
                          >
                            <ForwardIcon />
                            Forward
                          </MenuItem>
                        ) : null}
                      </Menu>
                    </Box>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <br />
                  <br />
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ width: '100%', textAlign: 'center', color: 'rgba(0,0,0,0.6)', mt: 4, mb: 6 }}
                  >
                    There are no queries at the moment
                  </Typography>
                  <br />
                  <br />
                </>
              )}
            </Grid>
          </div>
        </DialogContent>
        {/* Close Button */}
        <DialogActions>
          <Stack direction="row" spacing={2}>
            <Button
              variant="text"
              href="#contained-buttons"
              className="grey-btn"
              onClick={() => {
                setOpenQueryDialog(false);
                setIsSectionQuery(false);
              }}
            >
              Close
            </Button>
          </Stack>
        </DialogActions>
      </PopupComponent>
      {/* Query Resolved */}
      <PopupComponent
        open={confirmDailog}
        child
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
        <DialogContent sx={{ minWidth: 500, pt: 0 }}>
          <DialogContentText id="alert-dialog-description" sx={{ fontSize: '16px' }}>
            Mark the query as resolved
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setConfirmDailog(false);
              setUnResolvedQueryId(null);
            }}
            className="grey-btn"
          >
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={() => {
              setUpdateCategory('Resolve');
              handleUnresolvedQuery(unResolvedQueryId);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </PopupComponent>
      {/* Raise Query  Dialog */}
      <AppModal
        open={openRaiseQuery}
        title={formGroup.header}
        child
        saveButton={'Submit'}
        closeButton={'Cancel'}
        handleSubmit={handleSubmit}
        handleClose={() => setOpenRaiseQuery(false)}
        maxWidth="400px"
      >
        <FormLayoutBuilder
          initialValues={defaultValues}
          rules={rules}
          ref={formRef}
          groups={groups}
          columnSpacing={2}
        />
      </AppModal>
      {/* Forword Query */}
      <AppModal
        open={openForwordQuery}
        title={'Forward Query'}
        child
        saveButton={'Submit'}
        closeButton={'Cancel'}
        handleSubmit={handleSubmitForwordQ}
        handleClose={() => setOpenForwordQuery(false)}
        maxWidth="400px"
      >
        <FormLayoutBuilder
          initialValues={forwordQuerydefaultValues}
          rules={forwordQueryRules}
          ref={formRef}
          groups={forwordQueryGroups}
          columnSpacing={2}
        />
      </AppModal>
      {/* Delete Query */}
      <AppModal
        open={openDeleteQuery}
        title={'Remove Query'}
        child
        saveButton={'Yes'}
        closeButton={'No'}
        handleSubmit={handleDeleteQuery}
        handleClose={() => setOpenDeleteQuery(false)}
        maxWidth="360px"
      >
        <DialogContent sx={{ p: 0 }}>
          <DialogContentText id="alert-dialog-description" sx={{ fontSize: '16px' }}>
            Do you want to remove query?
          </DialogContentText>
        </DialogContent>
      </AppModal>
    </>
  );
}
